<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQIDataCompareChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {data: {xAxisData, legendData, seriesData}} = this
      let chartOpt = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legendData
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        grid: [{
          top: 30,
          right: 55,
          bottom: 50,
          left: 30,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: [{
          id: 0,
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          },
          position: 'left'
        }, {
          id: 1,
          type: 'value',
          name: 'μg/m3',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          },
          position: 'right'
        }, {
          id: 2,
          type: 'value',
          name: 'mg/m3',
          nameGap: 10,
          offset: 45,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          },
          position: 'right'
        }],
        color: ['#F6DA40', '#FF8772', '#fac858', '#FC5474', '#73c0de', '#BD97EB', '#00C2DF', '#9a60b4', '#ea7ccc'],
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: seriesData
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIDataComparesChart.vue